export default "__VITE_ASSET__CUbbpwTT__"